export default __webpack_public_path__ + "static/media/a4.c7585bab.jpg";